export default "__VITE_ASSET__IS4UntiC__"